import SuccessCaseImageModal from "../../../widgets/SuccessCaseImageModal/SuccessCaseImageModal";
import QuestionMark from "../../../../src/assets/question_mark.png"
import { Box, LinearProgress, Typography } from "@mui/material";
import ideasServices from "../../../services/ideasServices";
import { FileUploader } from "react-drag-drop-files";
import { ImagePlus, X } from "lucide-react";
import { useState } from "react";

export default function TempFileForModal () {
    const [openSuccessModal, setOpenSuccessModal] = useState(true);
    const [isImageLoading, setIsImageLoading] = useState(false);
    const [preview, setPreview] = useState<string | null>(null);
    const [progress, setProgress] = useState<number>(50);
    const [file, setFile] = useState<File>();

    const handleChange = (file: File) => {
        setFile(file);
        const reader = new FileReader();
        setIsImageLoading(true);
        setProgress(0);

        reader.onprogress = (e) => {
            if (e.lengthComputable) {
                const percent = Math.round((e.loaded / e.total) * 100);
                setProgress(percent);
            }
        };

        reader.onloadend = () => {
            setPreview(reader.result as string);
            setIsImageLoading(false);
        };

        reader.readAsDataURL(file);
    };

    const handleCancel = () => {
        setOpenSuccessModal(false);
        setFile(undefined);
    }

    const handleSave = async () => {
        if (file) {
            await ideasServices.markSuccessIdea(file, 50);
        }
        setFile(undefined);
    }
    
    return (
        <>
            <SuccessCaseImageModal 
                openSuccessModal={openSuccessModal} 
                setOpenSuccessModal={setOpenSuccessModal}
                title="¿Esta idea fue un éxito?"
                subtitle="Adjunta una imagen para mostrar esta idea en la sección de Casos de éxito."
                content={
                    !isImageLoading && !file ? (
                        <FileUploader
                            handleChange={handleChange}
                            multiple={false}
                        >
                            <Box className="sc-image-modal__content__image-container">
                                <ImagePlus size={50} />
                                <Typography>
                                    Arrastra una imagen aquí o haz click para adjuntar un archivo.<br/>
                                    (Dimensiones recomendadas: 1920x444px)
                                </Typography>
                            </Box>
                        </FileUploader>
                    )
                    : (
                        <Box className="sc-image-modal__content__image-loading">
                            <img 
                                className="sc-image-modal__content__image-loading__image"
                                src={preview ?? QuestionMark}
                                alt=""
                            />
                            <Box className="sc-image-modal__content__image-loading__info">
                                <Typography className="sc-image-modal__content__image-loading__info-name">
                                    {file?.name ?? "procesoadmision.png"}
                                </Typography>
                                <Typography className="sc-image-modal__content__image-loading__info-size">
                                    {file?.size ?? "1.2 MB"}
                                </Typography>
                                <Box sx={{ display: 'flex', flexDirection: 'row' }}>
                                    <LinearProgress 
                                        className="sc-image-modal__content__image-loading__info-bar"
                                        variant="determinate" 
                                        value={progress} 
                                    />
                                    <Typography className="sc-image-modal__content__image-loading__info-percentage">
                                        {progress}%
                                    </Typography>
                                </Box>
                            </Box>
                            <X 
                                className="sc-image-modal__content__image-loading__x"
                                onClick={() => {
                                    setFile(undefined);
                                }}
                            />
                        </Box>
                    )
                }
                nextButton="Guardar"
                disableButton={!file}
                save={handleSave}
                cancel={handleCancel}
            />
            {/* <SuccessCaseImageModal
                openSuccessModal={openSuccessModal}
                setOpenSuccessModal={setOpenSuccessModal}
                title="¿Quitar de los casos de éxito?"
                subtitle="Se eliminará también la imagen adjunta."
                nextButton="Quitar"
                cancel={() => setOpenSuccessModal(false)}
                save={() => ideasServices.unmarkSuccessIdea(50)}
                content={
                    <Box className="sc-image-modal__content__image-loading">
                        <img 
                            className="sc-image-modal__content__image-loading__image"
                            src={preview ?? QuestionMark}
                            alt=""
                        />
                        <Box className="sc-image-modal__content__image-loading__info">
                            <Typography className="sc-image-modal__content__image-loading__info-name">
                                {file?.name ?? "procesoadmision.png"}
                            </Typography>
                            <Typography className="sc-image-modal__content__image-loading__info-size">
                                {file?.size ?? "1.2 MB"}
                            </Typography>
                        </Box>
                    </Box>
                }
            /> */}
        </>
    )
}